/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Form as FormUi,
  Input,
  Checkbox,
  Dropdown,
  Container,
  Segment,
  Icon,
  Table,
} from "semantic-ui-react";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import cogoToast from "cogo-toast";
import allAxiosCommonTA from "../../components/axiosComponent/allAxiosCommonTA";

const DemapInvoice = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  t,
  movementType,
  ...props
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  let [isFormSubmitting, setIsFormSubmitting] = useState(false);

  useEffect(() => {

  }, [props.invoices]);
  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
  };

  let demapInvoice = () => {
		let invoiceIdsList = [];
		for (let index = 0; index < props.invoices.length; index++) {
			let invoiceID = props.invoices[index].id;
			invoiceIdsList.push(invoiceID)
		}
		console.log(invoiceIdsList)

		allAxiosCommonTA({
      url: "/deliveries/invoice/demap",
      method: "post",
      Items: { invoice_ids: invoiceIdsList },
    })
      .then((response) => {
        cogoToast.info(response.data.message, { hideAfter: 7.5 });
        setTimeout(() => {
          handleClose();
          window.location.reload();
        }, 100);
      })
      .catch((err) => {
        if (err?.response?.data?.message)
          cogoToast.error(err.response.data.message);
        else
          cogoToast.error("Error While Demapping invoice.");
      });
  }

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="small"
        style={{
          /* padding: '50px 0 50px 0' */
        }}
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            size="mini"
            color="green"
            className="m-2 w3-hover-green"
            circular
          >
            {"Demap Invoice"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          <div className="d-flex justify-content-between">
            <label className="font-weight-normal">{"Demap Invoice"}</label>
            <div className="form-inline">
              <i onClick={handleClose} className="fas fa-times"></i>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content scrolling>
          <label>Are you sure you want to demap the invoice?</label><br /><br />
          <div className="display-flex-center-justify-spacebtwn" style={{
            padding: '10px 0 10px 0'
          }}>
            <button
              className="submit-generate-order w3-button w3-blue w3-hover-blue w3-round w3-small"
              onClick={handleClose}
              disabled={isFormSubmitting}
            >
              {isFormSubmitting ? <Icon name="spinner" /> : <span>Cancel</span>}
            </button>
            <button
              className="submit-generate-order w3-button w3-blue w3-hover-blue w3-round w3-small"
              onClick={demapInvoice}
              disabled={isFormSubmitting}
            >
              {isFormSubmitting ? <Icon name="spinner" /> : <span>Demap Invoice</span>}
            </button>
          </div>
        </Modal.Content>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
// TODO: validation

export default DemapInvoice;
